import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";

/**
 *  获取操作系统
 */
export var getOS = function getOS() {
  var userAgent = navigator.userAgent.toLowerCase() || '',
      name = 'Unknown';

  if (userAgent.indexOf('win') > -1) {
    name = 'Windows';
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'Iphone';
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac';
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    name = 'Unix';
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android';
    } else {
      name = 'Linux';
    }
  }

  return name;
}; // 浏览器检查结果

export var browser = function browser(value) {
  var ua = window.navigator.userAgent;
  var ret = {},
      webkit = ua.match(/WebKit\/([\d.]+)/),
      chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
      ie = ua.match(/MSIE\s([\d\.]+)/) || ua.match(/(?:trident)(?:.*rv:([\w.]+))?/i),
      firefox = ua.match(/Firefox\/([\d.]+)/),
      safari = ua.match(/Safari\/([\d.]+)/),
      opera = ua.match(/OPR\/([\d.]+)/);
  webkit && (ret.webkit = _parseFloat(webkit[1]));
  chrome && (ret.chrome = _parseFloat(chrome[1]));
  ie && (ret.ie = _parseFloat(ie[1]));
  firefox && (ret.firefox = _parseFloat(firefox[1]));
  safari && (ret.safari = _parseFloat(safari[1]));
  opera && (ret.opera = _parseFloat(opera[1]));
  return ret;
};
/**
 * 获取UserAgent
 * 只维护Android和windows
 */

export var getUserAgent = function getUserAgent() {
  var ua = window.navigator.userAgent;
  return /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iPod|iOS/i.test(ua) ? 'iOS' : 'Windows';
};
/**
 *  获取用户浏览器是否为手机端
 */

export var getBroswerIsMobile = function getBroswerIsMobile() {
  var isMobile = false;

  try {
    isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  } catch (e) {}

  return isMobile;
};